import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import { TariffBlock } from '@beef/elk-common';
import { Metric } from "../../../../utils/metric";
import { selectUserType } from "../../../../store/selectors";
import { refreshTariffBlock } from "../store/actions";
import { selectIsTariffBlockPending, selectTariffBillingDate, selectTariffBlockError, selectTariffData, selectTariffLink, selectTariffPeriodDays, selectTariffPrice, selectTariffTitle } from "../Mobile/store";
import { selectIsFTTBUser } from "../store/selectors";
var _Tariff = function _Tariff(_ref) {
  var price = _ref.price,
    billingDate = _ref.billingDate,
    isPending = _ref.isPending,
    tariffUrl = _ref.tariffUrl,
    userType = _ref.userType,
    hasError = _ref.hasError,
    period = _ref.period,
    title = _ref.title,
    onRefreshTariffBlock = _ref.onRefreshTariffBlock;
  return /*#__PURE__*/React.createElement(Metric, {
    data: JSON.stringify({
      userType: userType
    }),
    events: {
      fubMetricSideMenu: ['handleTariffClick']
    },
    mode: "click",
    "data-t-id": "ConnectionBlock-Tariff"
  }, /*#__PURE__*/React.createElement(TariffBlock, {
    billingDate: billingDate,
    hasError: hasError,
    isPending: isPending,
    onRefresh: onRefreshTariffBlock,
    period: period,
    price: price,
    tariffUrl: tariffUrl,
    title: title,
    "data-t-id": "ConnectionBlock-Tariff"
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var isPending = selectIsTariffBlockPending(state);
  var hasError = selectTariffBlockError(state);
  return {
    price: selectTariffPrice(state),
    period: selectTariffPeriodDays(state),
    shouldRender: !selectIsFTTBUser(state) && (!!selectTariffData(state) || isPending || hasError),
    billingDate: selectTariffBillingDate(state),
    isPending: isPending,
    tariffUrl: selectTariffLink(state),
    userType: selectUserType(state),
    hasError: hasError,
    title: selectTariffTitle(state)
  };
};
var mapDispatchToProps = {
  onRefreshTariffBlock: refreshTariffBlock
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var Tariff = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(_Tariff);